var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCandidate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 1.88235C8.45965 1.88235 1.94118 8.20329 1.94118 16C1.94118 23.7967 8.45965 30.1176 16.5 30.1176C24.5404 30.1176 31.0588 23.7967 31.0588 16C31.0588 8.20329 24.5404 1.88235 16.5 1.88235ZM0 16C0 7.16424 7.38812 0 16.5 0C25.6119 0 33 7.16424 33 16C33 24.8358 25.6119 32 16.5 32C7.38812 32 0 24.8358 0 16Z",
    fill: "#00CFC5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6279 40L27 28.3721L28.3721 27L40 38.6279L38.6279 40Z",
    fill: "#00CFC5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8C14.344 8 13 9.344 13 11C13 12.656 14.344 14 16 14C17.656 14 19 12.656 19 11C19 9.344 17.656 8 16 8ZM11 11C11 8.238 13.238 6 16 6C18.762 6 21 8.238 21 11C21 13.762 18.762 16 16 16C13.238 16 11 13.762 11 11Z",
    fill: "#00CFC5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0002 16C13.244 16 10.8862 17.836 9.93272 20.436C9.79305 20.816 9.86935 21.158 10.1096 21.448C10.3703 21.762 10.8229 22 11.3444 22H20.6561C21.1775 22 21.6282 21.762 21.8889 21.448C22.1292 21.158 22.2074 20.816 22.0677 20.436C21.1142 17.836 18.7546 16 16.0002 16ZM8.20076 19.702C9.42432 16.364 12.4543 14 16.0002 14C19.5461 14 22.5761 16.364 23.7997 19.702C24.2262 20.862 23.9338 21.988 23.2801 22.778C22.6469 23.542 21.6766 24 20.6561 24H11.3444C10.3219 24 9.35358 23.542 8.71852 22.778C8.06484 21.988 7.77428 20.862 8.20076 19.702Z",
    fill: "#00CFC5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandidate);
export default __webpack_public_path__ + "static/media/candidate.6d0aa471db2b538a5a5022bd55491542.svg";
export { ForwardRef as ReactComponent };